import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import * as React from "react";
import cn from "twsx";

// Linear checkbox: 14×14, radius 3, 1px border-strong that darkens on hover,
// accent fill when checked or indeterminate, 1px accent focus outline.
/** Use when a person toggles an option on or off, or selects rows. */
const Checkbox = ({ checked, className, isIndeterminate, ref, ...props }: React.ComponentProps<typeof CheckboxPrimitive.Root> & {
  isIndeterminate?: boolean;
}) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      "peer flex size-3.5 shrink-0 items-center justify-center rounded-checkbox",
      "border border-border-strong bg-bg-surface text-text-on-accent outline-none hover:border-text-tertiary",
      "focus-visible:outline focus-visible:outline-1 focus-visible:outline-offset-2 focus-visible:outline-accent",
      "disabled:cursor-not-allowed disabled:opacity-50",
      "data-[state=checked]:border-control-checked data-[state=checked]:bg-control-checked",
      "data-[state=indeterminate]:border-control-checked data-[state=indeterminate]:bg-control-checked",
      className,
    )}
    checked={isIndeterminate ? "indeterminate" : checked}
    {...props}
  >
    <CheckboxPrimitive.Indicator className="flex items-center justify-center">
      {isIndeterminate
        ? (
          <svg width="8" height="2" viewBox="0 0 8 2" aria-hidden="true">
            <path d="M1 1h6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
          </svg>
        )
        : (
          <svg width="10" height="9" viewBox="0 0 10 9" fill="none" aria-hidden="true">
            <path d="M1.5 4.8l2.3 2.3L8.5 1.8" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        )}
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
);
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
